module.exports = __webpack_public_path__ + "img/theme_icon_bg.e3ed96f9.png";